var map = {
	"./headphones.png": 46,
	"./headphones_active.png": 47,
	"./home.png": 48,
	"./home_active.png": 49,
	"./link.png": 50,
	"./newspaper.png": 51,
	"./newspaper_active.png": 52,
	"./plus.png": 53,
	"./store.png": 54,
	"./store_active.png": 55,
	"./toolbox.png": 56,
	"./toolbox_active.png": 57,
	"./user.png": 58,
	"./users.png": 59,
	"./users_active.png": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;